import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Capacitor } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';
import { appHeaderActions } from '../redux';

export function useMobileKeyboardListener() {
    const dispatch = useDispatch();

    useEffect(() => {
        if (!Capacitor.isNativePlatform()) return undefined;

        const handles = [
            Keyboard.addListener('keyboardDidShow', () => {
                dispatch(appHeaderActions.setMobileKeyboardShowing(true));
            }),
            Keyboard.addListener('keyboardDidHide', () => {
                dispatch(appHeaderActions.setMobileKeyboardShowing(false));
            }),
        ];

        return () => {
            handles.forEach(handle => handle.then(h => h.remove()));
            dispatch(appHeaderActions.setMobileKeyboardShowing(false));
        };
    }, [dispatch]);
}
